import { Error } from "@mui/icons-material";
import { Card, Typography, styled } from "@mui/material";
import { FC } from "react";

const ErrorMessageCardStyled = styled(Card)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  padding: theme.spacing(2),
  border: "1px solid",
  borderColor: theme.palette.error.main,
  height: 150,
  color: theme.palette.error.main,
  display: "flex",
  gap: theme.spacing(2),
}));

interface ErrorMessageCardProps {
  errorMessage: string;
}

const ErrorMessageCard: FC<ErrorMessageCardProps> = ({ errorMessage }) => {
  return (
    <ErrorMessageCardStyled>
      <Error />
      <Typography variant="h6">{errorMessage}</Typography>
    </ErrorMessageCardStyled>
  );
};

export default ErrorMessageCard;
